import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./payments.css";

const PaymentSuccess = () => {
  const { txnId } = useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/stripepayment");
  };

  return (
    <div className="payment-card">
      <div className="payment-content-center">
        <div className="payment-status-icon success">
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="24" r="24" fill="#D1FADF"/>
            <path d="M16 24L22 30L32 18" stroke="#12B76A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        <h2 className="payment-status-success">Payment Successful</h2>
        <p>Your payment has been processed successfully!</p>
        <div className="txn-simple">TRANSACTION ID: <span>{txnId}</span></div>
        <button className="back-btn-better" onClick={handleBack}>Back to Home</button>
      </div>
    </div>
  );
};

export default PaymentSuccess;